<template>
	<div class="this-page">
		<template>
			<toolBar useSearch @search="searchOrder" @clear="clearSearch"/>
		</template>
		<template>
			<el-table :data="list" stripe style="width: 100%" size="small" :height="tableHeight"  border>
				<el-table-column prop="id" label="编号" width="61" fixed>
				</el-table-column>
				<el-table-column prop="avatar" label="头像" width="61">
					<template slot-scope="scope">
					    <el-avatar shape="square" :size="40" :src="scope.row.avatar"></el-avatar>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="申请团名称" min-width="200">
				</el-table-column>
        <el-table-column prop="avatar" label="团类型" width="61">
          <template slot-scope="scope">
            {{scope.row.billing_plan == 0?'重量':'体积'}}
          </template>
        </el-table-column>
				<el-table-column prop="owner_name" label="申请人昵称" min-width="120">
				</el-table-column>
				<el-table-column prop="owner" label="会员号" min-width="80">
				</el-table-column>
				<el-table-column prop="contact_name" label="联系人" min-width="120">
				</el-table-column>
				<el-table-column prop="contact_mobile" label="联系电话" min-width="120">
				</el-table-column>
				<el-table-column prop="address" label="联系地址" min-width="200">
				</el-table-column>
				<el-table-column prop="user_number" label="团内人数" width="80">
				</el-table-column>
				<el-table-column prop="package_number" label="团内包裹" width="80">
				</el-table-column>
				<el-table-column prop="total_weight" label="团总重量" width="120">
				</el-table-column>
        <el-table-column prop="total_volume" label="团总体积" width="120">
        </el-table-column>
				<el-table-column prop="total_price" label="总运费(不含GST)" width="120">
				</el-table-column>
				<el-table-column prop="created_at" label="开团时间" width="160">
				</el-table-column>
				<el-table-column prop="created_at" label="操作" width="100" fixed="right">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-search" circle size="mini" @click="getPackage(scope.row.id)" ></el-button>
						<el-button type="primary" icon="el-icon-s-custom" circle size="mini" @click="getGroupUser(scope.row.id,scope.row.owner)" ></el-button>

					</template>
				</el-table-column>
			</el-table>
			<template>
				<el-pagination style="margin-top:20px" :current-page="page" background layout="prev, pager, next" :page-count="pageCount"
				 @current-change="pageChange">
				</el-pagination>
			</template>
		</template>
		<el-dialog title="团员信息" :visible.sync="guShow">
		  <el-table :data="guList">
		    <el-table-column property="name" label="昵称" ></el-table-column>
			 <el-table-column property="uid" label="会员号"></el-table-column>
		    <el-table-column property="package_number" label="包裹数量" ></el-table-column>

			<el-table-column prop="created_at" label="操作" width="50" fixed="right">
				<template slot-scope="scope">
					<el-button type="primary" icon="el-icon-close" circle size="mini" @click="refundMember(scope.row.id)" v-if="scope.row.package_number == 0"></el-button>

				</template>
			</el-table-column>
		  </el-table>
		</el-dialog>
    <GroupPackageItems ref="groupPackage"/>
	</div>
</template>
<script>
  import GroupPackageItems from "@/components/GroupPackageItems";
	import toolBar from '../../components/tool-bar/index.vue'
	export default {
		components:{
			toolBar,
      GroupPackageItems
		},
		data() {
			return {
				tableHeight: document.documentElement.clientHeight - 165 + 'px',
				load: {
					list: false
				},
				page: 1,
				searchValue:'',
				pageCount: 1,
				list: [],
				package:[],
				packageShow:false,
				guShow:false,
				guList:[]
			}
		},
		mounted() {
			var that = this;
			// <!--把window.onresize事件挂在到mounted函数上-->
			window.onresize = () => {
				return (() => {
				  window.fullHeight = document.documentElement.clientHeight;

				  that.tableHeight = window.fullHeight - 165 + 'px';  // 高

				})()
			  };
			this.getList()
		},
		methods: {
			getList() {
				this.$fetch.post('Group/getGroupList', {
					page: this.page,
					status:1,
					search:this.searchValue
				}, true).then(res => {
					this.load.list = true
					this.list = res.result
					this.pageCount = res.page
				})
			},
			pageChange(e) {
				this.page = e
				this.getList()
			},
			searchOrder(e){
				if(!e){
					this.$message({
						type: 'info',
						message: '当前没有搜索任何信息'
					});
						return false
				}
				this.searchValue = e
				this.page = 1
				this.getList()

			},
			clearSearch(){
				console.log('清空搜索')
				this.searchValue = ''
				this.page = 1
				this.getList()
			},
			getDetail(){

			},
			reject(id,owner){
				this.$confirm('您将拒绝截团申请', '拒绝申请', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				}).then(() => {
					this.$fetch.post('Group/rejectDeliveryApply', {
						id: id,
						owner:owner,
					}, true).then(res => {
						this.page = 1
						this.getList()
					})
				}).catch(() => {
				  this.$message({
					type: 'info',
					message: '取消拒绝'
				  });
				});
			},
			adopt(id,owner){
				this.$fetch.post('Group/adoptDeliveryApply', {
					id: id,
					owner:owner
				}, true).then(res => {
					this.page = 1
					this.getList()
				})
			},
			getPackage(id){
        this.$refs.groupPackage.open(id,true)
			},
			getGroupUser(id,manager){
				this.guList = []
				this.$fetch.post('Group/getMember', {
					id: id,
					manager:manager
				}, true).then(res => {
					this.guShow = true
					this.guList = res
				})
			},
			refundMember(id){
				this.$fetch.post('Group/refundMember', {
					id: id
				}, true).then(res => {
					this.getList()
					this.guShow = false
					this.$message({
						type: 'success',
						message: '团员退出成功'
					});
				})
			}
		}
	}
</script>

<style scoped>
	.this-page {
		padding: 10px;
		background-color: #FFFFFF;
	}
</style>
